import { Button, ButtonProps } from "@mui/material";
import theme from "assets/styles/themes";
import { useIntl } from "react-intl";

interface TClearFilterButtonProps extends ButtonProps {
    translationId?: string;
}

const ClearFilterButton = ({ translationId, children, ...props }: TClearFilterButtonProps) => {
    const intl = useIntl();

    return (
        <Button
            size="small"
            sx={{
                padding: 0,
                height: 36,
                fontSize: 12,
                letterSpacing: "1.25px",
                color: theme.palette.primary.dark,
                "&.Mui-disabled": {
                    color: theme.palette.text.disabled,
                },
                "& .MuiButton-startIcon>*:nth-of-type(1)": {
                    fontSize: 12,
                },
                "& .MuiButton-startIcon": {
                    marginRight: 0.7,
                },
            }}
            {...props}
        >
            {intl.formatMessage({ id: translationId ?? "advancedpeersearch.clearFilters" })}
        </Button>
    );
};

export default ClearFilterButton;
